export const accountObjectiveModal = {
	es: {
		header: "Objetivos",
		incomeTitle: "Ingresos",
		income: "Priorizar los ingresos por intereses o dividendos o productos\
			similares con baja exposición al riesgo de capital",
		longTermGrowthTitle: "Crecimiento a largo plazo",
		longTermGrowth:
			"Priorizar el crecimiento del capital sobre las ganancias a corto plazo",
		shortTermGrowthTitle: "Crecimiento a corto plazo",
		shortTermGrowth:
			"Priorizar estrategias de inversión agresivas que supongan un mayor\
		riesgo/volatilidad que la inversión media.",
	},
	en: {
		header: "Objectives",
		incomeTitle: "Income",
		income: "Prioritize income from interest, dividends or similar products\
			with low exposure to risk",
		longTermGrowthTitle: "Long-term growth",
		longTermGrowth: "Prioritize capital growth over short-term gains",
		shortTermGrowthTitle: "Short-term growth",
		shortTermGrowth:
			"Prioritize aggressive investment strategies which\
		assume a greater risk/volatility than an average investment",
	},
};
